import { useId } from 'react'
import { useTranslation } from 'react-i18next'

import { AuthLanguageSwitcher } from '@/features/auth/components/locale-switcher'
import { SettingsBackLink } from '../components/settings-back-link'

/**
 * App settings (D-099): the language selector moves here from the profile
 * screen; future releases add theme/biometric/storage choices to this page so
 * the profile stays a read-only card.
 */
export function SettingsAppScreen() {
  const { t } = useTranslation()
  const headingId = useId()

  return (
    <section
      aria-labelledby={headingId}
      className="content-width min-h-dvh pb-10 pt-[var(--safe-top)]"
    >
      <div className="mx-auto w-full max-w-[640px] px-0.5 md:px-0">
        <div className="flex items-center gap-2 py-3">
          <SettingsBackLink to="/settings" />
          <h1 id={headingId} className="text-[28px] leading-tight font-bold">
            {t('screens.settings.app')}
          </h1>
        </div>

        <div className="mt-4 space-y-3">
          <div className="flex min-h-13 flex-wrap items-center gap-3 rounded-[18px] border border-line bg-white px-4 py-3">
            <span className="font-bold text-deep">
              {t('profileSocial.profile.fields.locale')}
            </span>
            <AuthLanguageSwitcher className="ml-auto inline-flex items-center gap-2" />
          </div>
        </div>

      </div>
    </section>
  )
}
